module.exports = {
  SORT_POPULARITY: "popularity",
  SORT_NAME: "name",
  SORT_PRICE: "price",
  SORT_SALE: "sale",
  SORT_DISTANCE: "distance",
  SORT_VIP: "vip",
}
